import { Box, Text } from "theme-ui";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";

import * as styles from "./ImageCallOut.styles";
import { selectUserChoiceValues } from "store/app";

function getBackgroundImageUrl({
  userChoiceValues,
  backgroundImageOptions = {},
}) {
  const customisationCategory = backgroundImageOptions.customisation;
  const userSelection = userChoiceValues[customisationCategory];

  return backgroundImageOptions.values[userSelection];
}

export default function ImageCallOut({
  backgroundColor,
  desktopPosition = {},
  mobilePosition = {},
  zIndex,
  backgroundImageOptions,
  bottomText,
}) {
  const userChoiceValues = useSelector(selectUserChoiceValues);

  const backgroundImageUrl = getBackgroundImageUrl({
    userChoiceValues,
    backgroundImageOptions,
  });

  if (!backgroundImageUrl) {
    return null;
  }

  return (
    <Box sx={styles.personalizationCallOut({ zIndex })}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <Box
          sx={styles.callout({
            backgroundColor,
            desktopPosition,
            mobilePosition,
            zIndex,
          })}
        >
          <Box
            sx={styles.calloutImage({
              backgroundImageUrl,
            })}
          ></Box>
          {bottomText && (
            <Box sx={styles.bottomTextContainer}>
              <Text as="div" sx={styles.bottomText}>
                {bottomText}
              </Text>
            </Box>
          )}
        </Box>
      </motion.div>
    </Box>
  );
}
